/* =====================================================================
   CUSTOM CHANGE START – youmee-home.js
   Youmee.market Startseite – Interaktionen der ym-Sections
   Neue Datei (kein Original vorhanden) · Stand 2026-10-16
   Funktioniert auch im Theme-Editor (Sections neu laden / umsortieren).
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- Hero-Slider ---------- */
  if (!customElements.get('ym-hero')) {
    class YmHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ym-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.ym-hero__dot'));
        this.index = 0;
        if (this.slides.length < 2) return;

        const prev = this.querySelector('.ym-hero__nav--prev');
        const next = this.querySelector('.ym-hero__nav--next');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        // Wischen auf Touch-Geräten
        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        });

        const seconds = parseInt(this.dataset.autoplay || '0', 10);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (seconds > 0 && !reduce && !window.Shopify?.designMode) {
          this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('focusin', () => this.stop());
        }
      }
      disconnectedCallback() { this.stop(); }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      go(i, byUser) {
        if (byUser) this.stop();
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const on = k === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        this.dots.forEach((d, k) => {
          const on = k === this.index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
    }
    customElements.define('ym-hero', YmHero);
  }

  /* ---------- Produkt-Slider (Pfeile) ---------- */
  if (!customElements.get('ym-slider')) {
    class YmSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ym-slider__track');
        this.prev = this.querySelector('.ym-slider__arrow--prev');
        this.next = this.querySelector('.ym-slider__arrow--next');
        if (!this.track) return;
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.onScroll); }
      step(dir) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 20;
        const w = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
      reset() { this.track.scrollLeft = 0; this.update(); }
    }
    customElements.define('ym-slider', YmSlider);
  }

  /* ---------- Tabs (Neu / Secondhand / Sale) ---------- */
  if (!customElements.get('ym-tabs')) {
    class YmTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const n = this.tabs.length;
            const j = (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
            this.select(j);
            this.tabs[j].focus();
          });
        });
      }
      select(i) {
        this.tabs.forEach((tab, k) => {
          const on = k === i;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !on;
            if (on) {
              const slider = panel.querySelector('ym-slider');
              if (slider && slider.reset) slider.reset();
            }
          }
          const more = this.querySelector('[data-more="' + tab.dataset.tab + '"]');
          if (more) more.hidden = !on;
        });
      }
    }
    customElements.define('ym-tabs', YmTabs);
  }

  /* ---------- Footer-Akkordeon (Desktop: immer offen, Mobile: aufklappbar) ---------- */
  if (!customElements.get('ym-foot-acc')) {
    const mq = window.matchMedia('(max-width: 800px)');
    class YmFootAcc extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        if (!this.details || !this.summary) return;
        this.onClick = (e) => { if (!mq.matches) e.preventDefault(); };
        this.onChange = () => this.sync();
        this.summary.addEventListener('click', this.onClick);
        mq.addEventListener('change', this.onChange);
        this.sync();
      }
      disconnectedCallback() { mq.removeEventListener('change', this.onChange); }
      sync() {
        this.details.open = !mq.matches;
        if (mq.matches) this.summary.removeAttribute('tabindex');
        else this.summary.setAttribute('tabindex', '-1');
      }
    }
    customElements.define('ym-foot-acc', YmFootAcc);
  }

  /* ---------- Newsletter → Klaviyo (Client Subscriptions API) ---------- */
  if (!customElements.get('ym-newsletter')) {
    class YmNewsletter extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form[data-klaviyo]');
        if (!this.form) return; // ohne Klaviyo-IDs läuft das normale Shopify-Formular
        this.form.addEventListener('submit', (e) => this.submit(e));
      }
      async submit(e) {
        e.preventDefault();
        const email = this.form.querySelector('input[type="email"]').value.trim();
        const btn = this.form.querySelector('button[type="submit"]');
        const ok = this.querySelector('.ym-nl__msg--ok');
        const err = this.querySelector('.ym-nl__msg--error');
        if (err) err.hidden = true;
        if (!email) return;
        btn.disabled = true;

        const body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.source || 'Startseite',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
          }
        };

        try {
          const res = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.company),
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
              body: JSON.stringify(body)
            }
          );
          if (!res.ok) throw new Error('Klaviyo ' + res.status);
          this.form.hidden = true;
          if (ok) ok.hidden = false;
        } catch (error) {
          if (err) err.hidden = false;
          btn.disabled = false;
        }
      }
    }
    customElements.define('ym-newsletter', YmNewsletter);
  }
})();
/* CUSTOM CHANGE END – youmee-home.js */
